import React from "react";
import PropTypes from "prop-types";
import { Map } from "immutable";
import { connect } from "react-redux";
import { change, Field, formValueSelector } from "redux-form";
import * as actions from "MODULES/companies/actions";
import {
  form,
  Form as AppForm,
  Select,
  FormInput,
  Check
} from "MODULES/shared/components/Forms";
import countries from "LIB/countries";
import { states } from "LIB/states";
import validate from "../validate";

const renderStateField = country =>
  country === "US" ? (
    <Field
      name={"state"}
      component={Select}
      options={states}
      label="State/Province/Region"
      required
    />
  ) : (
    <Field
      name={"state"}
      component={FormInput}
      label="State/Province/Region"
      required
    />
  );

export class Form extends React.Component {
  state = {
    sameAsBillingAddress: true
  };
  componentWillReceiveProps(nextProps) {
    if (this.props.country && nextProps.country !== this.props.country) {
      this.props.resetStateField();
    }
    this.props.requestPrimaryAddress();
  }

  toggleBillingAddress() {
    if (this.state.sameAsBillingAddress && this.props.billing) {
      const address = this.props.billing.toJS();
      this.props.initialize(address);
    } else {
      this.props.initialize();
    }
    this.setState(state => ({
      sameAsBillingAddress: !state.sameAsBillingAddress
    }));
  }

  render() {
    const countryOptions = countries.map(c => ({
      value: c.code,
      text: c.name
    }));
    return (
      <AppForm {...this.props}>
        <AppForm.Body>
          <div className="form-group">
            <div className="btn-group" data-toggle="buttons">
              <Field
                onChange={() => this.toggleBillingAddress()}
                name="same_as_billing"
                component={Check}
                label="Copy Billing Address"
              />
            </div>
          </div>
          <div className="row row-col-gutters-half">
            <div className="col-md-9">
              <Field
                name="country"
                component={Select}
                label="Country"
                options={countryOptions}
                required
              />
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor="primary" className="control-label">
                  Primary Address
                </label>
                <br />
                <div
                  className="btn-group full-width-checkbox"
                  data-toggle="buttons"
                >
                  <Field
                    className="physicalAddressPrimary"
                    name="primary"
                    component={Check}
                    label="Yes"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row row-col-gutters-half">
            <div className="col-md-6">
              <Field name="care_of" component={FormInput} label="C/O" />
            </div>
          </div>
          <div className="row row-col-gutters-half">
            <div className="col-md-6">
              <Field
                name="line1"
                component={FormInput}
                label="Address Line 1"
                required
              />
            </div>
            <div className="col-md-6">
              <Field
                name="line2"
                component={FormInput}
                label="Address Line 2"
              />
            </div>
          </div>
          <div className="row row-col-gutters-half">
            <div className="col-md-5">
              <Field name="city" component={FormInput} label="City" required />
            </div>
            <div className="col-md-4">
              {renderStateField(this.props.country)}
            </div>
            <div className="col-md-3">
              <Field
                name="postal_code"
                component={FormInput}
                label="Zip/Postal Code"
                required
              />
            </div>
          </div>
        </AppForm.Body>
      </AppForm>
    );
  }
}

Form.propTypes = {
  country: PropTypes.string,
  billing: PropTypes.instanceOf(Map),
  resetStateField: PropTypes.func.isRequired
};

const selector = formValueSelector("createPhysicalAddress");

export default connect(
  state => ({
    country: selector(state, "country"),
    billing: state.companyDetail.getIn(["company", "billing_address"])
  }),
  dispatch => ({
    onSubmit: data => dispatch(actions.createPhysicalAddress(data)),
    requestPrimaryAddress: () => dispatch(actions.update()),
    resetStateField: () =>
      dispatch(change("createPhysicalAddress", "state", ""))
  })
)(
  form({
    form: "createPhysicalAddress",
    validate
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/PhysicalAddresses/Create/Form.jsx